import CheckIcon from "@/assets/pricing/32C997_check_icon.svg?react";
import CrossIcon from "@/assets/pricing/FF5A4F_times_icon.svg?react";
import {type FC} from "react";
import {useTranslation} from "react-i18next";

const PERMISSION_GUIDE = {
  ADMIN: [
    {translationKey: "view_campaigns_and_influencers", can: true},
    {translationKey: "manage_campaigns", can: true},
    {translationKey: "invite_to_account", can: true},
    {translationKey: "manage_permissions", can: true},
    {translationKey: "manage_card_information", can: true},
    {translationKey: "purchase_content_buyouts", can: true},
    {translationKey: "download_ad_codes", can: true},
  ],
  WRITE: [
    {translationKey: "view_campaigns_and_influencers", can: true},
    {translationKey: "manage_campaigns", can: true},
    {translationKey: "invite_to_account", can: true},
    {translationKey: "manage_permissions", can: true},
    {translationKey: "purchase_content_buyouts", can: true},
    {translationKey: "download_ad_codes", can: true},
    {translationKey: "manage_card_information", can: false},
  ],
  PURCHASE: [
    {translationKey: "view_campaigns_and_influencers", can: true},
    {translationKey: "purchase_content_buyouts", can: true},
    {translationKey: "download_ad_codes", can: true},
    {translationKey: "manage_campaigns", can: false},
    {translationKey: "invite_to_account", can: false},
    {translationKey: "manage_permissions", can: false},
    {translationKey: "manage_card_information", can: false},
  ],
  READ: [
    {translationKey: "view_campaigns_and_influencers", can: true},
    {translationKey: "download_ad_codes", can: true},
    {translationKey: "manage_campaigns", can: false},
    {translationKey: "invite_to_account", can: false},
    {translationKey: "manage_permissions", can: false},
    {translationKey: "purchase_content_buyouts", can: false},
    {translationKey: "manage_card_information", can: false},
  ],
};

const PermissionGuide: FC = () => {
  const {t} = useTranslation("multi_account");

  return (
    <div className="flex flex-col gap-2">
      {Object.keys(PERMISSION_GUIDE).map(userPermission => (
        <div className="bg-neutral-white-dark flex flex-col gap-6 rounded-lg p-4 md:flex-row">
          <span className="text-neutral-black min-w-36 text-xs font-extrabold">
            {t(`${userPermission.toLowerCase()}_permissions`)}
          </span>
          <div className="flex flex-col gap-2">
            {PERMISSION_GUIDE[userPermission as "ADMIN"].map(permission => (
              <div className="flex items-center gap-1">
                {permission.can ? <CheckIcon className="size-3 shrink-0" /> : <CrossIcon className="size-3 shrink-0" />}
                <span className="text-neutral-black text-xs">
                  {t(permission.can ? "can" : "cant")} {t(permission.translationKey)}
                </span>
              </div>
            ))}
          </div>
        </div>
      ))}
    </div>
  );
};

export default PermissionGuide;
